/* PrettSun · 内嵌视频增强（文章页 + 列表卡通用）

   【两端策略不同，因为两端成因不同】
   桌面（>749px）：点封面 → 页内注入 iframe（www.youtube.com + enablejsapi + origin）并自动播放；
                   点时间戳 → 滚回播放器 + postMessage seekTo 跳秒。已稳定可用。
   手机（≤749px）：**仍留在页面内播放**，但改用「最兼容的 vanilla 嵌入」：
                   · 域名 youtube-nocookie.com —— 它天生就是为"不依赖第三方 cookie"设计的，
                     而 Safari 恰好在掐第三方 cookie（这正是"登录了也还是提示"的根因）
                   · **不带 enablejsapi / origin**（手机端不需要脚本控制；脚本控制是 bot 常见向量，可能招更严校验）
                   · 时间戳用 `&start=<秒>` 重载 iframe 来跳秒（不需要 JS API）
   ⚠️ 桌面端务必保留 enablejsapi=1 + origin（YouTube 文档要求二者成对）。 */
(function () {
  'use strict';
  var ORIGIN = window.location.origin;
  var MOBILE = (function () {
    try { return window.matchMedia('(max-width: 749px)').matches; } catch (e) { return false; }
  })();

  function embedUrl(id, start) {
    var p = ['autoplay=1', 'rel=0', 'modestbranding=1', 'playsinline=1'];
    if (start) p.push('start=' + start);
    if (MOBILE) {
      // 最兼容：隐私增强域名，不带 enablejsapi/origin
      return 'https://www.youtube-nocookie.com/embed/' + id + '?' + p.join('&');
    }
    p.push('enablejsapi=1', 'origin=' + encodeURIComponent(ORIGIN));
    return 'https://www.youtube.com/embed/' + id + '?' + p.join('&');
  }

  function makeFrame(box, src) {
    var ifr = document.createElement('iframe');
    ifr.setAttribute('src', src);
    ifr.setAttribute('title', box.getAttribute('data-title') || 'Video review');
    ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; ' +
      'gyroscope; picture-in-picture; web-share');
    ifr.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    ifr.setAttribute('allowfullscreen', '');
    return ifr;
  }

  function play(box, start) {
    var id = box.getAttribute('data-video-id');
    if (!id) return null;
    var existing = box.querySelector('iframe');
    if (existing && start) {
      // 手机端跳秒：重载 iframe（不依赖 JS API）
      existing.setAttribute('src', embedUrl(id, start));
      return existing;
    }
    if (existing) return existing;
    var ifr = makeFrame(box, embedUrl(id, start));
    box.classList.add('is-playing');
    box.appendChild(ifr);
    var poster = box.querySelector('.yt-embed__poster');
    if (poster) poster.remove();
    return ifr;
  }

  function scrollToBox(box) {
    try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    catch (e) { box.scrollIntoView(); }
  }

  /* 桌面：postMessage 跳秒 */
  function seek(ifr, sec) {
    var send = function () {
      try {
        ifr.contentWindow.postMessage(JSON.stringify({
          event: 'command', func: 'seekTo', args: [sec, true]
        }), '*');
      } catch (e) { /* 跨域失败则忽略 */ }
    };
    send(); setTimeout(send, 500); setTimeout(send, 1500);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // ① 点封面 → 两端都在页内播放，只是参数不同
    var poster = t.closest('.yt-embed__poster');
    if (poster) {
      e.preventDefault();
      var box = poster.closest('.yt-embed');
      if (box) play(box, 0);
      return;
    }

    // ② 点时间戳
    var a = t.closest('a[href*="youtube.com/watch"]');
    if (!a) return;
    var mm = a.getAttribute('href').match(/[?&]t=(\d+)s?/);
    if (!mm) return;
    var host = a.closest('.blog-post-content') || document;
    var box2 = host.querySelector('.yt-embed');
    if (!box2) return;
    var sec = parseInt(mm[1], 10);
    e.preventDefault();
    scrollToBox(box2);

    if (MOBILE) { play(box2, sec); return; }   // 重载跳秒

    var ifr = box2.querySelector('iframe');
    if (ifr) { seek(ifr, sec); return; }
    var made = play(box2, 0);
    if (!made) return;
    var tries = 0;
    var timer = setInterval(function () {
      var f = box2.querySelector('iframe');
      tries++;
      if (f) { clearInterval(timer); setTimeout(function () { seek(f, sec); }, 500); }
      else if (tries > 40) { clearInterval(timer); }
    }, 120);
  });
})();
